// angular import
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// project import
import { AdminComponent } from './demo/layout/admin';
import { EmptyComponent } from './demo/layout/empty/empty.component';
import { AuthGuardChild } from './@theme/helpers/auth.guard';
import { LoginComponent } from './demo/pages/auth/authentication-1/login/login.component';

//Type
import { Role } from './@theme/types/role';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    children: [
      {
        path: 'login',
        loadComponent: () => import('./demo/pages/auth/authentication-1/login/login.component').then((c) => c.LoginComponent)
      }
    ]
  },
  {
    path: '',
    component: AdminComponent,
    canActivateChild: [AuthGuardChild],
    children: [
      {
        path: '',
        loadChildren: () => import('./demo/pages/dashboard/dashboard.module').then((m) => m.DashboardModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },

      {
        path: 'widget',
        loadChildren: () => import('./demo/pages/widget/widget.module').then((m) => m.WidgetModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'online-course',
        loadChildren: () => import('./demo/pages/admin-panel/online-courses/online-courses.module').then((m) => m.OnlineCoursesModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'membership',
        loadChildren: () => import('./demo/pages/admin-panel/membership/membership.module').then((m) => m.MembershipModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'helpdesk',
        loadChildren: () => import('./demo/pages/admin-panel/helpdesk/helpdesk.module').then((m) => m.HelpdeskModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'invoice',
        loadChildren: () => import('./demo/pages/admin-panel/invoice/invoice.module').then((m) => m.InvoiceModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'application',
        loadChildren: () => import('./demo/pages/application/application.module').then((m) => m.ApplicationModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'apex-chart',
        loadComponent: () => import('./demo/pages/chart/apex-charts/apex-charts.component').then((c) => c.ApexChartsComponent),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'material-table',
        loadComponent: () => import('./demo/pages/material-table/material-table.component').then((c) => c.MaterialTableComponent),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'forms',
        loadChildren: () => import('./demo/pages/forms/forms.module').then((m) => m.FormsModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'price',
        loadChildren: () => import('./demo/pages/price/price-routing.module').then((m) => m.PriceRoutingModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'sample-page',
        loadComponent: () => import('./demo/pages/other/sample-page/sample-page.component').then((c) => c.SamplePageComponent),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'facturas',
        loadChildren: () => import('./demo/pages/facturas/facturas.module').then((m) => m.FacturasModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'firmas',
        loadChildren: () => import('./demo/pages/firmasPM/firmas.module').then((m) => m.FirmasModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'plataformas',
        loadChildren: () => import('./demo/pages/plataformas/plataformas.module').then((m) => m.PlataformasModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'remesasDomicilio',
        loadChildren: () => import('./demo/pages/remesasDomicilio/remesasDomicilio.module').then((m) => m.RemesasDomicilioModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'retenciones',
        loadChildren: () => import('./demo/pages/retenciones/retenciones.module').then((m) => m.RetencionesModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'mallaCompensacion',
        loadChildren: () => import('./demo/pages/mallaCompensacion/mallaCompensacion.module').then((m) => m.enteCompensadorModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'chequex',
        loadChildren: () => import('./demo/pages/chequex/chequex.module').then((m) => m.chequexModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'administrador',
        loadChildren: () => import('./demo/pages/administrador/administrador.module').then((m) => m.AdministradorModule)
      },
      {
        path: 'depositoEmpresarial',
        loadChildren: () => import('./demo/pages/depositoEmpresarial/depositoEmpresarial.module').then((m) => m.depositoEmpresarialModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'empresas',
        loadChildren: () => import('./demo/pages/empresas/empresas.module').then((m) => m.EmpresasModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'bancos',
        loadChildren: () => import('./demo/pages/bancos/bancos.module').then((m) => m.BancosModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'usuarios',
        loadChildren: () => import('./demo/pages/usuarios/usuarios.module').then((m) => m.UsuariosModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'compensacion',
        loadChildren: () => import('./demo/pages/compensacion/compensacion.module').then((m) => m.CompensacionModule),
        data: { roles: [Role.Admin] }
      },
      {
        path: 'vistaAlgoritmo',
        loadChildren: () => import('./demo/pages/vistaAlgoritmo/vistaAlgoritmo.module').then((m) => m.VistaAlgoritmoModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'reportes',
        loadChildren: () => import('./demo/pages/reportes/reportes.module').then((m) => m.ReportesModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'busqueda',
        loadChildren: () => import('./demo/pages/busqueda/busqueda.module').then((m) => m.BusquedaModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'confirmacion',
        loadChildren: () => import('./demo/pages/confirmacion/confirmacion.module').then((m) => m.ConfirmacionModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'generadorFacturas',
        loadChildren: () => import('./demo/pages/generador-facturas/generador-facturas.module').then((m) => m.GeneradorFacturasModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'capturaPanini',
        loadChildren: () => import('./demo/pages/capturaPanini/capturaPanini.module').then((m) => m.CapturaPaniniModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'iconos',
        loadChildren: () => import('./demo/pages/iconos/iconos.module').then((m) => m.IconosModule),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'facturasPayFact',
        loadChildren: () => import('./demo/pages/facturasPayFact/facturasPayFact.module').then((m) => m.FacturasPayFactModule),
        data: { roles: [Role.Admin, Role.User] }
      },
      {
        path: 'retencionesPayFact',
        loadChildren: () => import('./demo/pages/retencionesPayFact/retencionesPayFact.module').then((m) => m.RetencionesPayFactModule),
        data: { roles: [Role.Admin, Role.User] }
      },
      {
        path: 'busquedaPayFact',
        loadChildren: () => import('./demo/pages/busquedaPayFact/busquedaPayFact.module').then((m) => m.BusquedaPayFactModule),
        data: { roles: [Role.Admin, Role.User] }
      },
      {
        path: 'reportesPayFact',
        loadChildren: () => import('./demo/pages/reportesPayFact/reportesPayFact.module').then((m) => m.ReportesPayFactModule),
        data: { roles: [Role.Admin, Role.User] }
      },
      {
        path: 'historicosTrueque',
        loadChildren: () => import('./demo/pages/historicos_trueque/historicos_trueque.module').then((m) => m.HistoricosModule),
        data: { roles: [Role.Admin, Role.User] }
      }
    ]
  },
  {
    path: '',
    component: EmptyComponent,
    children: [
      {
        path: '',
        redirectTo: '/auth/login',
        pathMatch: 'full'
      },

      {
        path: 'otp',
        loadComponent: () => import('./demo/pages/auth/authentication-1/otp/otp.component').then((c) => c.OtpComponent)
      },
      {
        path: 'productos',
        loadComponent: () =>
          import('./demo/pages/auth/authentication-1/plataformaVista/plataformaVista.component').then((c) => c.PlataformaVistaComponent)
      },

      {
        path: 'register',
        loadComponent: () => import('./demo/pages/auth/authentication-1/register/register.component').then((c) => c.RegisterComponent)
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./demo/pages/auth/authentication-1/forgot-password/forgot-password.component').then((c) => c.ForgotPasswordComponent)
      },
      {
        path: 'authentication-1',
        canActivateChild: [AuthGuardChild],
        loadChildren: () => import('./demo/pages/auth/authentication-1/authentication-1.module').then((e) => e.Authentication1Module),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'authentication-2',
        canActivateChild: [AuthGuardChild],
        loadChildren: () => import('./demo/pages/auth/authentication-2/authentication-2.module').then((e) => e.Authentication2Module),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'authentication-3',
        canActivateChild: [AuthGuardChild],
        loadComponent: () =>
          import('./demo/pages/auth/authentication-3/authentication-three.component').then((c) => c.AuthenticationThreeComponent),
        data: { roles: [Role.Admin, Role.User, Role.AdminEmp] }
      },
      {
        path: 'maintenance',
        loadChildren: () => import('./demo/pages/maintenance/maintenance.module').then((m) => m.MaintenanceModule)
      },
      {
        path: 'unauthorized',
        loadComponent: () => import('./demo/pages/maintenance/error-401/error-401.component').then((c) => c.Error401Component)
      }
    ]
  },
  {
    path: '**',
    loadComponent: () => import('./demo/pages/maintenance/error/error.component').then((c) => c.ErrorComponent)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
